const Colors = {
	red: "#F1634F",
	blue: "#3e90c1",
	green: "#53a93f",
	green2: "#4EB076",
	paleGreen: "#00C49F",
	cyan: "#21BBD7",
	orange: "#FF8042",

	get Objects() {
		return {
			feedback: {
				type: this.blue,
			},
		};
	},
};

export default Colors;
